import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);
var MenuContext = function MenuContext(props) {
  var context = {
    getItemRender: props.getItemRender
  };
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: props.children
  });
};
MenuContext.displayName = "MenuContext";
function useMenuContext() {
  return React.useContext(Context);
}

export { MenuContext, useMenuContext };
